/**
 * Unread state for a ticket row.
 *
 * The AUTHORITATIVE unread computation lives server-side (`deriveUnread` in the
 * domain), because it needs `submitter_last_viewed_at` — a column that is never
 * sent on the user wire. The client therefore trusts the server's `unread` flag.
 *
 * This helper layers a local optimistic suppression on top: the moment a user
 * opens a ticket we record its id in `locallyViewedIds` and clear the dot
 * immediately, rather than waiting for `markFeedbackViewed` to round-trip and the
 * list to refetch. Once the refetch lands, the server's `unread` is false anyway.
 */
export function isTicketUnread(
  item: { id: string; unread: boolean },
  locallyViewedIds: ReadonlySet<string>,
): boolean {
  return item.unread && !locallyViewedIds.has(item.id)
}
